import React from 'react';
import SvgIconProp from './SvgIconProp';
import logoHeader from '../img/logo-header.png';

export const IconCactusLogoHorizontal = (props: SvgIconProp) => (
    <img
        style={props.styles}
        className={props.class}
        src={process.env.REACT_APP_HEADER_LOGO_URI || logoHeader}
        alt="logo"
    />
);
